<template>
    <div>
        <div>
            <div class="header">
                <div class="container">
                    <div class="header-content">
                        <a class="logo-link" href="http://www.kolumbus.no">
                            <img src="../assets/images/site-logo.svg" />
                        </a>
                        <div class="header-right">
                            <ul class="header-login">
                                <li v-if="authenticated">
                                    <a v-bind:href="`/${app_locale}/account`" style="margin-right:10px;">{{
                                        $t('header.my_account') }}</a>
                                    <a v-on:click.prevent="signOut()">{{ $t('header.sign_out') }}</a>
                                </li>
                                <li v-else>
                                    <a v-bind:href="`/${app_locale}/signup`" style="margin-right:10px;">{{
                                        $t('header.signup') }}</a>
                                    <a onclick="document.getElementById('n1-signin-modal').style.display='block'">{{
                                        $t('header.signin') }}</a>

                                </li>
                            </ul>
                            <div class="header-languages hidden-mobile">
                                <div class="n2-dropdown-hover">
                                    <a v-on:click="changeLanguage()"> {{ the_other_language }}</a>
                                </div>
                            </div>
                            <span class="menu-toggle visible-mobile" style="display:block;"
                                v-on:click="toogleNavVisible">
                                <i class="fa fa-bars" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="header-links" v-bind:class="{ 'hidden-mobile': !nav_bar_visible }">
                <div class="container">
                    <ul class="header-mobile-languages visible-mobile">
                        <li>
                            <a v-on:click="changeLanguage()"> {{ the_other_language }}</a>
                        </li>
                    </ul>
                    <ul class="header-menu">
                        <li>
                            <a v-bind:href="'/'">{{ $t('header.link_home') }}<span
                                    class="hidden-md-up glyphicon glyphicon-arrow-right"></span></a>
                        </li>
                        <li>
                            <a v-bind:href="`/${app_locale}/term-online-sale`">{{ $t('header.link_term_purchase')
                                }}<span class="hidden-md-up glyphicon glyphicon-arrow-right"></span></a>
                        </li>
                        <li>
                            <a v-bind:href="`/${app_locale}/term-reservation`">{{ $t('header.link_term_reservation')
                                }}<span class="hidden-md-up glyphicon glyphicon-arrow-right"></span></a>
                        </li>
                        <li>
                            <a v-bind:href="`/${app_locale}/term-auto-pass`">{{ $t('header.link_term_auto_pass')
                                }}<span class="hidden-md-up glyphicon glyphicon-arrow-right"></span></a>
                        </li>
                        <li>
                            <a v-bind:href="`/${app_locale}/cancellation`">{{ $t('header.link_term_cancellation')
                                }}<span class="hidden-md-up glyphicon glyphicon-arrow-right"></span></a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

        <router-view />
        <div class="footer">
            <div class="container">
                <div class="footer-container n2-text-center">
                    <p class="h1">
                        <a href="tel:177">
                            <img class="circle circle-large" src="../assets/images/phone-177-circle-white.svg" />
                        </a>
                    </p>
                    <p class="footer-text">{{ $t('footer.text_call_from_aborad_phone_number') }}</p>
                    <p class="footer-text"><i>{{ $t('footer.text_call_from_aborad_phone_desc') }}</i></p>
                </div>
            </div>
        </div>
        <div v-if="authenticated">
            <div id="n1-inactive-modal" class="w3-modal" style="display: block;" v-if="logout_warning_modal_visible">
                <div class="w3-modal-content w3-card-4" style="max-width:500px;position:relative;">
                    <div class="w3-container">
                        <h4 class="n2-text-center">{{ $t('layout.text_inactive_header') }}</h4>
                        <p>{{ $t('layout.text_inactive_message1') }} {{ count_down }} {{
                            $t('layout.text_inactive_message2') }}</p>
                        <p>{{ $t('layout.text_inactive_message3') }}</p>
                        <div class="n2-text-center n2-margin">
                            <button v-on:click="keepLogged($event)" class="n2-button-1">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="n1-auto-logged-out" class="w3-modal" style="display: block;" v-if="loggged_out_modal_visible">
            <div class="w3-modal-content w3-card-4" style="max-width:500px;position:relative;">
                <div class="w3-container">
                    <h4 class="n2-text-center">{{ $t('layout.text_auto_signed_out_title') }}</h4>
                    <p class="n2-text-center">{{ $t('layout.text_auto_signed_out_description') }}</p>
                    <div class="n2-text-center n2-margin">
                        <button v-on:click="consentLoggedOutMessage()" class="n2-button-1">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="n1-signin-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="w3-container">
                    <signin></signin>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Signin from '../components/app/signin.vue'
import { IdentityService } from '../services'



export default {
    name: 'MainLayout',
    components: {
        Signin
    },
    data() {
        return {
            count_down: 0,
            last_token_time: null,
            refresh_token_timer: null,
            warning_timer: null,
            logout_timer: null,
            count_down_timer: null,
            //inactive_time_before_warn: 1000 * 10,
            //warning_time_before_logout: 1000 * 5,
            inactive_time_before_warn: 1000 * 60 * 15,
            warning_time_before_logout: 1000 * 45,
            logout_warning_modal_visible: false,
            loggged_out_modal_visible: false
        }
    },
    computed: {
        ...mapGetters('identity', [
            'authenticated'
        ]),
        ...mapGetters('app_settings', [
            'nav_bar_visible'
        ]),
        ...mapGetters('globalization', [
            'app_locale',
            'language',
            'languages'
        ]),
        the_other_language: function () {
            return this.app_locale == 'en' ? 'Norsk' : 'English'
        }
    },
    created: async function () {
        this.last_token_time = new Date();
        this.identityService = new IdentityService();

        await this.checkCookieTime();
        this.startWarningTimer();
        this.refresh_token_timer = setInterval(this.refreshToken, 1000 * 10);
    },
    beforeMount: function () {
        window.addEventListener("click", this.startWarningTimer);
        window.addEventListener("keydown", this.startWarningTimer);
    },
    beforeDestroy: function () {
        window.removeEventListener("click", this.startWarningTimer);
        window.removeEventListener("keydown", this.startWarningTimer);

        this.clearTimers();
        if (this.refresh_token_timer) {
            clearInterval(this.refresh_token_timer);
            this.refresh_token_timer = null;
        }
    },
    methods: {
        checkCookieTime: async function () {
            if (this.authenticated) {
                let last_active = await this.$store.dispatch('identity/get_last_active');
                let compareTimeLogout = new Date(new Date(last_active).getTime() + this.inactive_time_before_warn + this.warning_time_before_logout);
                if (!last_active || new Date() > compareTimeLogout) {
                    await this.signOut();
                }
            }
        },
        clearTimers: function () {
            if (this.warning_timer) {
                clearTimeout(this.warning_timer);
                this.warning_timer = null;
            }
            if (this.logout_timer) {
                clearTimeout(this.logout_timer);
                this.logout_timer = null;
            }
            if (this.count_down_timer) {
                clearInterval(this.count_down_timer);
                this.count_down_timer = null;
            }
        },
        startLogoutTimer: function () {
            if (this.authenticated) {
                this.clearTimers();
                this.openLogoutModal();
                //console.log('start count', new Date())
                this.countDown();
                this.count_down_timer = setInterval(this.countDown, 1000);
                this.logout_timer = setTimeout(this.autoSignOut, this.warning_time_before_logout);
            }
        },
        autoSignOut: async function () {
            await this.signOut();
            this.loggged_out_modal_visible = true;
        },
        startWarningTimer: function () {
            if (!this.logout_warning_modal_visible) {
                this.clearTimers();
                if (this.authenticated) {
                    this.$store.dispatch('identity/update_last_active');
                }

                this.warning_timer = setTimeout(this.startLogoutTimer, this.inactive_time_before_warn);

            }
        },
        consentLoggedOutMessage: function () {
            this.loggged_out_modal_visible = false;
        },
        openLogoutModal: function () {
            //console.log('show modal')
            this.logout_warning_modal_visible = true;
            //document.getElementById('n1-inactive-modal').style.display = 'block';
        },
        refreshToken: async function () {
            //get new token every hour
            if (this.authenticated) {
                let comparer = new Date((new Date(this.last_token_time)).getTime() + 60 * 60 * 1000);
                if (new Date() > comparer) {
                    this.last_token_time = new Date();
                    await this.identityService.refreshToken();
                }
            }
        },
        countDown: async function () {
            //get new token every hour
            if (this.authenticated) {
                let last_active = await this.$store.dispatch('identity/get_last_active');
                console.log('count down', last_active)
                //console.log('count', new Date())
                //console.log('last_active', last_active)

                let compareTimeLogout = new Date(new Date(last_active).getTime() + this.inactive_time_before_warn + this.warning_time_before_logout);
                this.count_down = Math.floor((compareTimeLogout - new Date()) / 1000);
                //console.log(compareTimeLogout, this.count_down)

            }


        },
        changeLanguage() {
            let locale = this.app_locale == 'en' ? 'no' : 'en'
            if (locale !== this.$route.params.lang) {
                const to = this.$router.resolve({ params: { lang: locale }, query: this.$route.query })
                //this.$router.push(to.location)
                let p = to.location.path;
                if (p.length > 1 && p.slice(-1) == '/') {
                    p = p.substr(0, p.length - 1);
                }
                this.$router.push({ path: p, query: this.$route.query })
            }
        },
        toogleNavVisible: async function () {
            this.$store.commit('app_settings/set_nav_bar_visible', !this.nav_bar_visible);
        },
        keepLogged: async function () {
            this.logout_warning_modal_visible = false;
            this.startWarningTimer();
            //this.closeModal();
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
        signOut: async function () {
            this.clearTimers();
            this.logout_warning_modal_visible = false;
            try {
                await this.$store.dispatch('identity/signout');
                if (this.$route.path.split('/').some(a => a == 'account')) {
                    this.$router.push({
                        path: '/'
                    });
                }
            }
            catch {
                this.model_errors = { sign_in: [this.$t('components.signin.error_sign_out')] }
            }

        }
    }
}
</script>
